import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const fetchViolateReasons = createAction(Constants.FETCH_VIOLATE_REASONS.REQUEST, filter => filter);
